import { RouteComponentProps } from 'react-router';
import { useAppSelector } from '../../app/hooks';
import { Button } from '../../components';
import Spinner from '../../components/common/Spinner';
import { P2 } from '../../styles/FontStyles';
import { AuthLayoutTitle, Box, Flexed } from '../../styles/GlobalComponents';
import { colors, globalImages } from '../../styles/GlobalStyles';
import { Main } from '../../layout/AuthLayout/authLayoutStyled';
import { AuthLogo } from '../../styles/stylesStyled';
import { Icon, IconCustomer } from '../../styles/Icons';
import { UserType } from '../Dashboard/Dashboard';
import { Dispatch, SetStateAction } from 'react';

const SignUp = ({
  setUserTypeModal,
  setTermsConditionsModal,
  setUserType
}: {
  setUserTypeModal: (modal: boolean) => void;
  setTermsConditionsModal: (modal: boolean) => void;
  setUserType: Dispatch<SetStateAction<UserType>>;
}) => {
  const { loading } = useAppSelector((state) => state.auth);

  return (
    <Main>
      {loading && <Spinner fullScreen={true} transparent />}
      <AuthLogo>
        <img src={globalImages.authLayoutLogo} alt='logo' />
      </AuthLogo>

      <AuthLayoutTitle>Sign Up</AuthLayoutTitle>

      <Box
        mb='20'
        mt='20'
        bg='#DAD9DD'
        border={`1px solid ${colors.neutral900}`}
        p='20px'
        br='30px'>
        <P2 mb='15'>
          As a customer, enjoy United One products at Retail cost.
        </P2>

        <Button
          color='#C4C3C6'
          textColor={colors.neutral900}
          fontFamily='Nulshock'
          onClick={() => {
            setUserTypeModal(false);
            setTermsConditionsModal(true);
            setUserType(UserType.CUSTOMER);
          }}>
          Continue as Customer
          {/* <Icon>
            <IconCustomer />
          </Icon> */}
        </Button>
      </Box>
      <Box
        bg='#DAD0C9'
        border={`1px solid ${colors.neutral900}`}
        p='20px'
        mb='0'
        br='30px'>
        <P2 mb='15'>
          Start your business now, share these incredible products and the
          United One vision across the globe and seize the first-mover advantage
          at the inception of a company destined for greatness.
        </P2>
        <Button
          fontFamily='Nulshock'
          onClick={() => {
            setUserTypeModal(false);
            setTermsConditionsModal(true);
            setUserType(UserType.PARTNER);
          }}>
          Continue as Partner{' '}
        </Button>
      </Box>
    </Main>
  );
};

export default SignUp;
